import React from 'react';
import { Link } from 'react-router-dom';

const categories = [
  { id: 'actualites', name: 'Actualités' },
  { id: 'histoire', name: 'Histoire' },
  { id: 'culture', name: 'Culture' },
  { id: 'politique', name: 'Politique' },
  { id: 'sport', name: 'Sport' },
  { id: 'justice', name: 'Justice' },
];

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-stone-900 text-stone-300" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <Link to="/" className="block" data-testid="footer-logo">
              <img 
                src="https://customer-assets.emergentagent.com/job_versailles-actu/artifacts/x061u1gg_logo%20Versailles%2B.jpeg" 
                alt="Versailles Plus" 
                className="h-16 object-contain brightness-0 invert"
              />
            </Link>
            <p className="font-lora text-sm text-stone-400 mt-4 leading-relaxed">
              Votre source d'information locale sur Versailles et ses environs depuis 2007. 
              Actualités, histoire, culture et vie locale.
            </p>
          </div>
          
          {/* Categories */}
          <div>
            <h3 className="font-inter text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Rubriques
            </h3>
            <ul className="space-y-3">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/categorie/${cat.id}`}
                    data-testid={`footer-nav-${cat.id}`}
                    className="font-inter text-sm text-stone-400 hover:text-white transition-colors duration-200"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          
          {/* Legal */}
          <div>
            <h3 className="font-inter text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Informations
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/mentions-legales"
                  data-testid="footer-mentions-legales"
                  className="font-inter text-sm text-stone-400 hover:text-white transition-colors duration-200"
                >
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link
                  to="/admin/login"
                  data-testid="footer-admin-link"
                  className="font-inter text-sm text-stone-400 hover:text-white transition-colors duration-200"
                >
                  Espace rédaction
                </Link>
              </li>
            </ul>
            
            <div className="mt-8">
              <p className="font-inter text-xs text-stone-500">
                Édité par Le Pool Presse SAS
              </p>
              <p className="font-inter text-xs text-stone-500 mt-1">
                SIREN 831 276 001
              </p>
            </div>
          </div>
        </div>
        
        {/* Bottom bar */}
        <div className="border-t border-stone-800 mt-12 pt-8">
          <p className="font-inter text-xs text-stone-500 text-center">
            © {currentYear} VersaillesPlus.fr - Tous droits réservés
          </p>
        </div>
      </div>
    </footer>
  );
};
